import React from "react";
import PropTypes from "prop-types";
import {Link} from "gatsby";

export const CustomLink = ({linkType, linkURL, children, className = "", activeClassName = "", onClick = null}) => {
    /*if(linkType === 'internal') {
        if (
            linkURL
            && !linkURL.endsWith('.html')
            && !linkURL.endsWith('/')
            && !linkURL.includes('#')
            && !linkURL.endsWith('.txt')
            && !linkURL.endsWith('.exe')
            && !linkURL.endsWith('.zip')
        ) {
            linkURL += '/';
        }

        if (linkURL && linkURL.includes('#')) {
            let urlParts = linkURL.split('#');
            if (!urlParts[0].endsWith('/')) {
                urlParts[0] += '/';
            }

            linkURL = urlParts.join('#');
        }
    }*/

    if (linkType === "internal") {
        return (
            <Link className={className} activeClassName={activeClassName} to={linkURL} onClick={onClick}>
                {children}
            </Link>
        );
    } else if (linkType === "external") {
        return (
            <a className={className} href={linkURL} target="_blank" rel="noreferrer" onClick={onClick}>
                {children}
            </a>
        );
    } else if (linkType === 'static') {
        return (
            <a className={className} target="_self" href={linkURL} onClick={onClick}>
                {children}
            </a>
        );
    } else {
        return (
            <Link className={className} activeClassName={activeClassName} to={linkURL} onClick={onClick}>
                {children}
            </Link>
        );
    }
};

CustomLink.propTypes = {
    linkType: PropTypes.string
};

CustomLink.defaultProps = {
    prefetch: false
};

export default CustomLink;
